module.exports = __webpack_public_path__ + "static/media/seaplaneport.02fac995.svg";